<div class="std-margin flex space-between">
  <span class="pointer uppercase bold" (click)="selectMode()">
    <i class="fa hlf-margin-right" [ngClass]="{'fa-clock': mode == 'time', 'fa-user-tie': mode == 'subject'}"></i>
    {{(mode=='time' ? 'Xem theo thời gian' : 'Xem theo đối tượng') | lang}}
  </span>

  <date-picker [force]="true" [handler]="handler"></date-picker>
</div>

<panel *ngIf="range && !loading">
  <div header>
    <ng-container *ngFor="let i of path; index as ix">
      <span [ngClass]="{'text-primary pointer': ix + 1 < path.length}" (click)="open(i)">{{i.Name}}</span>
      <span class="hlf-margin-left hlf-margin-right" *ngIf="ix + 1 < path.length">|</span>
    </ng-container>  
  </div>

  <text-filter *ngIf="mode == 'time'" right [target]="paymentsByDate" [placeholder]="'Tìm thời gian'"></text-filter>
  <table responsive class="hover data"  *ngIf="mode == 'time'">
    <tr>
      <th class="text-top text-right" priority="3">STT</th>
      <th class="text-top text-left" priority="1"><sortable [target]="paymentsByDate" [selected]="true" [extractor]="dgExtractor('Date')">Thời gian</sortable></th>
      <th class="text-top text-right" priority="2"><sortable [target]="paymentsByDate" [extractor]="dgExtractor('PartnerIncome')">Thu đối tác</sortable></th>
      <th class="text-top text-right" priority="2"><sortable [target]="paymentsByDate" [extractor]="dgExtractor('ServiceIncome')">Thu dịch vụ</sortable></th>
      <th class="text-top text-right" priority="2"><sortable [target]="paymentsByDate" [extractor]="dgExtractor('PartnerExpense')">Chi đối tác</sortable></th>
      <th class="text-top text-right" priority="2"><sortable [target]="paymentsByDate" [extractor]="dgExtractor('ServiceExpense')">Chi dịch vụ</sortable></th>
      <th class="text-top text-right" priority="1"><sortable [target]="paymentsByDate" [extractor]="dgExtractor('Total')">Tổng</sortable></th>
    </tr>
    <tr *ngFor="let i of paymentsByDate.pageMatches; index as ix">
      <td><small>{{ix + 1 + paymentsByDate.pageIndex * paymentsByDate.pageSize}}</small></td>
      <td>
        <b class="bold spacy uppercase" [ngClass]="{'text-primary pointer': i.children.length > 0}" (click)="open(i)">{{i.Name}}</b>
      </td>
      <td>
        <span [ngClass]="{'text-success': i.PartnerIncome > 0}">{{i.PartnerIncome | number : '1.0-0' : 'en-US'}}</span><vnd></vnd>
        <br />
        <small *ngIf="i.PartnerIncome > 0" class="pointer" (click)="view(i, 'partner', 'income')">{{count(i, 'partner', 'income') | number : '1.0-0' : 'en-US'}}<unit>phiếu</unit><i class="fa fa-info-circle text-primary hlf-margin-left"></i></small>
      </td>
      <td>
        <span [ngClass]="{'text-success': i.ServiceIncome > 0}">{{i.ServiceIncome | number : '1.0-0' : 'en-US'}}</span><vnd></vnd>
        <br />
        <small *ngIf="i.ServiceIncome > 0" class="pointer" (click)="view(i, 'service', 'income')">{{count(i, 'service', 'income') | number : '1.0-0' : 'en-US'}}<unit>phiếu</unit><i class="fa fa-info-circle text-primary hlf-margin-left"></i></small>
      </td>
      <td>
        <span [ngClass]="{'text-danger': i.PartnerExpense > 0}">{{i.PartnerExpense | number : '1.0-0' : 'en-US'}}</span><vnd></vnd>
        <br />
        <small *ngIf="i.PartnerExpense > 0" class="pointer" (click)="view(i, 'partner', 'expense')">{{count(i, 'partner', 'expense') | number : '1.0-0' : 'en-US'}}<unit>phiếu</unit><i class="fa fa-info-circle text-primary hlf-margin-left"></i></small>
      </td>
      <td>
        <span [ngClass]="{'text-danger': i.ServiceExpense > 0}">{{i.ServiceExpense | number : '1.0-0' : 'en-US'}}</span><vnd></vnd>
        <br />
        <small *ngIf="i.ServiceExpense > 0" class="pointer" (click)="view(i, 'service', 'expense')">{{count(i, 'service', 'expense') | number : '1.0-0' : 'en-US'}}<unit>phiếu</unit><i class="fa fa-info-circle text-primary hlf-margin-left"></i></small>
      </td>
      <td>
        <number [good]="'positive'" [sign]="true" [value]="i.PartnerIncome + i.ServiceIncome - i.PartnerExpense - i.ServiceExpense" [decimal]="0"></number>
        <vnd></vnd>
      </td>
    </tr>
    <tr *ngIf="paymentsByDate.pages.length > 1">
      <td class="hidden"></td>
      <td [colSpan]="6" class="text-center"><pagination [target]="paymentsByDate"></pagination></td>
    </tr>
    <tr class="footer" *ngIf="paymentsByDate.matches.length > 1">
      <td></td>
      <td><b>{{'TỔNG' | lang}} ({{paymentsByDate.matches.length}})</b></td>
      <td [ngClass]="{'text-success': dgSum('PartnerIncome') > 0}"><b>{{dgSum('PartnerIncome') | number : '1.0-0' : 'en-US'}}</b><vnd></vnd></td>
      <td [ngClass]="{'text-success': dgSum('ServiceIncome') > 0}"><b>{{dgSum('ServiceIncome') | number : '1.0-0' : 'en-US'}}</b><vnd></vnd></td>
      <td [ngClass]="{'text-danger': dgSum('PartnerExpense') > 0}"><b>{{dgSum('PartnerExpense') | number : '1.0-0' : 'en-US'}}</b><vnd></vnd></td>
      <td [ngClass]="{'text-danger': dgSum('ServiceExpense') > 0}"><b>{{dgSum('ServiceExpense') | number : '1.0-0' : 'en-US'}}</b><vnd></vnd></td>
      <td><number class="bold" [good]="'positive'" [sign]="true" [decimal]="0" [value]="dgSum('Total')"></number><vnd></vnd></td>
    </tr>
  </table>

  <text-filter *ngIf="mode == 'subject'" right [target]="paymentsBySubject" [placeholder]="'Tìm đối tượng'"></text-filter>
  <table responsive class="hover data" *ngIf="mode == 'subject'">
    <tr>
      <th class="text-right" priority="3" style="width: 0">STT</th>
      <th class="text-left" priority="1"><sortable [target]="paymentsBySubject" [selected]="true" [extractor]="sgExtractor('Date')">Đối tượng</sortable></th>
      <th class="text-right" priority="2"><sortable [target]="paymentsBySubject" [extractor]="sgExtractor('Income')">Thu</sortable></th>
      <th class="text-right" priority="2"><sortable [target]="paymentsBySubject" [extractor]="sgExtractor('Expense')">Chi</sortable></th>
      <th class="text-right" priority="1"><sortable [target]="paymentsBySubject" [extractor]="sgExtractor('Total')">Tổng</sortable></th>
    </tr>
    <tr *ngFor="let i of paymentsBySubject.pageMatches; index as ix">
      <td><small>{{ix + 1 + paymentsBySubject.pageIndex * paymentsBySubject.pageSize}}</small></td>
      <td>
        <b class="bold spacy uppercase" [ngClass]="{'text-primary pointer': i.children.length > 0}" (click)="open(i)">{{i.Name}}</b>
      </td>
      <td>
        <span [ngClass]="{'text-success': i.Income > 0}">{{i.Income | number : '1.0-0' : 'en-US'}}</span><vnd></vnd>
        <br />
        <small *ngIf="i.Income > 0" class="pointer" (click)="view(i, 'any', 'income')">{{count(i, 'any', 'income') | number : '1.0-0' : 'en-US'}}<unit>phiếu</unit><i class="fa fa-info-circle text-primary hlf-margin-left"></i></small>

      </td>
      <td>
        <span [ngClass]="{'text-danger': i.Expense > 0}">{{i.Expense | number : '1.0-0' : 'en-US'}}</span><vnd></vnd>
        <br />
        <small *ngIf="i.Expense > 0" class="pointer" (click)="view(i, 'any', 'expense')">{{count(i, 'any', 'expense') | number : '1.0-0' : 'en-US'}}<unit>phiếu</unit><i class="fa fa-info-circle text-primary hlf-margin-left"></i></small>
      </td>
      <td>
        <number [good]="'positive'" [sign]="true" [value]="i.Income - i.Expense" [decimal]="0"></number><vnd></vnd>
      </td>
    </tr>
    <tr *ngIf="paymentsBySubject.pages.length > 1">
      <td class="hidden"></td>
      <td [colSpan]="5" class="text-center"><pagination [target]="paymentsBySubject"></pagination></td>
    </tr>
    <tr class="footer" *ngIf="paymentsBySubject.matches.length > 1">
      <td></td>
      <td><b>{{'TỔNG' | lang}} ({{paymentsBySubject.matches.length}})</b></td>
      <td [ngClass]="{'text-success': sgSum('Income') > 0}"><b>{{sgSum('Income') | number : '1.0-0' : 'en-US'}}</b><vnd></vnd></td>
      <td [ngClass]="{'text-danger': sgSum('Expense') > 0}"><b>{{sgSum('Expense') | number : '1.0-0' : 'en-US'}}</b><vnd></vnd></td>
      <td><number class="bold" [good]="'positive'" [sign]="true" [decimal]="0" [value]="sgSum('Total')"></number><vnd></vnd></td>
    </tr>
  </table>

</panel>

<ngx-loading [show]="loading" [config]="{fullScreenBackdrop: true}"></ngx-loading>
